export const isNameValid = (name: string): boolean => {
    const pattern = /^[a-zA-Z0-9À-ÿœŒçÇ\-_.(),!?;:–—&'"’"«»„“” ]+$/;
    return pattern.test(name);
};

export const isEmailValid = (email: string): boolean => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
};
